import { LatLng } from "./common/lat-lng.model";
import { Country } from "./common/country.model";

export class TransportationAgency {
  rowId: number | null = null;
  placeId: string | null = null;
  agencyName: string | null = null;
  crNumber: number | null = null;
  motAgencyLicenseNumber: string | null = null;
  phoneNumber: string | null = null;
  website: string | null = null;
  location: LatLng | null = null;
  countryId: number | null = null;
  country: Country | null = null;
  address: string | null = null;
  logo: string | null = null;
  emailAddress: string | null = null;
  defaultContactId: number | null = null;
  companyId: number | null = null;
}
